import { render, staticRenderFns } from "./modify-contact.vue?vue&type=template&id=f9fda6c8"
import script from "./modify-contact.vue?vue&type=script&lang=js"
export * from "./modify-contact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports